import './index.scss';

import { Auth0Provider } from '@auth0/auth0-react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <BrowserRouter>
    <Auth0Provider
      domain={import.meta.env.REACT_APP_AUTH0_DOMAIN!}
      clientId={import.meta.env.REACT_APP_AUTH0_CLIENTID!}
      useRefreshTokens={true}
      authorizationParams={{
        redirect_uri: import.meta.env.REACT_APP_AUTH0_REDIRECT,
      }}
    >
      <App />
    </Auth0Provider>
  </BrowserRouter>,
);

reportWebVitals();
